module.exports = __webpack_public_path__ + "img/T1B_xs_01.5528f325.png";